/**
 * 'Begleitfahrt' user services
 *
 * Scope: This Service provides reusable functions the user-management in the 'begleitfahrt' module.
 */

export default {
  /**
   * Filter open evaluations
   *
   * @param {object} user
   * @returns {boolean}
   */
  filterOpenEvaluations(user) {
    /**
     * If the 'show only open evaluations' switch is active
     * -> check if the evaluation is open
     */
    const showOnlyOpenMatches = user.evaluations.open > 0;

    return showOnlyOpenMatches;
  },

  /**
   * Get closed ratings counter
   *
   * @param {number} userId
   * @param {object} ratingsByUserId - userId to array of ratings
   * @param {object} questionnaireById - questionnaireId to questionnaire object
   *
   * @returns {number} amount of closed ratings
   */
  getCompletedRatingsCountForUser(userId, ratingsByUserId, questionnaireById) {
    const closedUserRatings = ratingsByUserId[userId];
    return closedUserRatings ? closedUserRatings.filter((r) => questionnaireById[r.questionnaireIdFk] !== undefined).length : 0;
  },

  /**
   * Get open ratings counter
   *
   * @param {number} userId
   * @param {object} questionnaireLocalData rating-array from vuex store
   *
   * @returns {number} amount of open ratings
   */
  getOpenRatingsCountForUser(userId, questionnaireLocalData) {
    if (!questionnaireLocalData) return 0;

    let openRatings = questionnaireLocalData[`${userId}`];
    return openRatings ? Object.keys(openRatings).length : 0;
  },

  filterRecord(record, dataSource, sourceKey, type) {
    return dataSource[record[sourceKey]] !== undefined && record.isType === type;
  },

  getOpenRatingsCount(userId, questionnaireLocalData, questionnaireById) {
    const openRatings = questionnaireLocalData[`${userId}`];

    if (openRatings) {
      return Object.values(openRatings).filter((r) => this.filterRecord(r, questionnaireById, 'questionnaireId', 'questionnaire')).length;
    }

    return 0;
  },

  getClosedRatingsCount(userId, questionnaireById, ratingsByUserId) {
    const closedRatings = ratingsByUserId[`${userId}`];

    if (closedRatings) {
      return Object.values(closedRatings).filter((r) => this.filterRecord(r, questionnaireById, 'questionnaireIdFk', 'questionnaire')).length;
    }

    return 0;
  },
  getOpenEvaluationsCount(userId, questionnaireLocalData, questionnaireById) {
    const openRatings = questionnaireLocalData[`${userId}`];

    if (openRatings) {
      return Object.values(openRatings).filter((r) => this.filterRecord(r, questionnaireById, 'questionnaireId', 'evaluation')).length;
    }

    return 0;
  },
  getClosedEvaluationsCount(userId, questionnaireById, ratingsByUserId) {
    const closedRatings = ratingsByUserId[`${userId}`];

    if (closedRatings) {
      return Object.values(closedRatings).filter((r) => this.filterRecord(r, questionnaireById, 'questionnaireIdFk', 'evaluation')).length;
    }

    return 0;
  },
};
